import RecordDetails from "../recordDetails/recordDetails";
import React, { useEffect, useState } from "react";
import { AccessLevel, RowLevelAction } from "../../types/types";
import { GetRequest, replaceWithCurrentApiVersion } from "../../utils/api";

interface Props {
  urlparams: Map<string, string>;
  platformAction: RowLevelAction;
  setOpen: (value: boolean) => void;
  blueprintApi: string;
  title: string;
  isCreateFlow?: boolean;
  userAccessLevel: AccessLevel;
  moduleCode: string;
  viewPageBluPrint?: any;
  allowEdits: boolean;
  onSuccess?: (value: any) => void;
}

const RecordDetailsUsingBlueprintApi: React.FC<Props> = ({
  urlparams,
  setOpen,
  blueprintApi,
  isCreateFlow,
  userAccessLevel,
  platformAction,
  moduleCode,
  allowEdits,
  viewPageBluPrint,
  onSuccess
}) => {
  const [blurpintInfo, setBlurpintInfo] = useState<any>({});

  useEffect(() => {
    if (blueprintApi) {
      getViewData(blueprintApi);
    }
  }, [blueprintApi]);

  // this doesnt need to take a redux route as its redundant to store in global state.
  const getViewData = (blueprintApi: string) => {

    if (blueprintApi?.length > 0) {
      GetRequest(replaceWithCurrentApiVersion(blueprintApi)).then((response) => {
        setBlurpintInfo(response);
      })
    }
  };

  return (
    <>
      <RecordDetails
        isCreateFlow={isCreateFlow}
        editForm={blurpintInfo ? blurpintInfo.editForm : []}
        dependantFields={
          blurpintInfo?.dependency ? blurpintInfo.dependency : []
        }
        viewPageBluPrint={{ ...(viewPageBluPrint ?? blurpintInfo), hideEmptyFeilds: false }}
        dataApi={blurpintInfo ? blurpintInfo.dataApi : ""}
        dataApiMapper={blurpintInfo ? blurpintInfo.dataApiMapper : []}
        createApiMapper={blurpintInfo ? blurpintInfo.createApiMapper : []}
        viewApi={blurpintInfo ? blurpintInfo.viewApi : ""}
        createApi={blurpintInfo ? blurpintInfo.createApi : ""}
        recordId={urlparams.get("recordId") ?? ""}
        urlparams={urlparams}
        setOpen={setOpen}
        userAccessLevel={userAccessLevel}
        //refreshData={refreshData}
        platformAction={platformAction}
        parentEntity={blurpintInfo ? blurpintInfo.parentEntity : ""}
        //recordIds={recordIds}
        //refreshTable={refreshTable}
        allowEdits={allowEdits ?? true}
        //selectedRows={selectedRows}
        //prefillColumns={prefillColumns}
        moduleCode={moduleCode}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default React.memo(RecordDetailsUsingBlueprintApi);
